import React, { useEffect } from "react";
import "./About.css";

const About = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.5 }
    );

    document.querySelectorAll(".fade-in").forEach((el) => {
      observer.observe(el);
    });
  }, []);

  return (
    <div className="about-container">
      <section className="about-header">
        <h1 style={{textAlign:"center"}}>About Us</h1>
        <p>
        Geega Resources Management Limited by Guarantee is a youth empowerment initiative for
the Southern Nigerian youths (Southeast, South-south and Southwest) and was conceived
because of the burning desire on the part of the founder, Gerald Uchenna Nnamokwor Esq, to
assist the less privileged Nigerians in meeting up with the basic needs of life. It is his strong
belief that if productivity is increased in Nigeria, there will be massive food items as well as
other commodities used in daily lives at the cheapest possible prices. Having travelled to
different countries of the world, including the United Kingdom, The Peoples Republic of China,
Etc., Mr. Nnamokwor discovered that where there is abundance of commodities in the market,
the prices of goods automatically drop down. He also discovered that to boost the economy of
any country, such a country, must make judicious use of its human resources.
It was based on the above that Mr. Nnamokwor founded Geega Resources with the primary
aim of empowering Southern Nigerian youths through the creation of local employment
opportunities in agriculture, manufacturing and commerce to make food items and other
commodities extremely accessible and affordable to Nigerians.
Upon concluding his master’s degree in international commercial law at the very Prestigious
University of Bradford, England, United Kingdom in the year 2023, Mr. Nnamokwor began the
journey towards actualizing his dreams. He began to organize other Nigerians in diaspora and
began to share his dreams of establishing Geega Resources to help the poor masses in
Nigeria and on October 23, 2024, Geega Resources was established.
        </p>
      </section>

      <section className="about-content">
        <div className="about-section fade-in" id="objectives">
          <h2>Objectives of Geega Resources</h2>
          <p>
            The objectives include acquiring machinery from advanced countries to
            engage youths in agriculture and other industries like shoe, clothing,
            furniture, water, and bread production. These initiatives aim to
            subsidize prices and improve accessibility for Nigeria's poor.
          </p>
        </div>

        <div className="about-section fade-in" id="vision">
          <h2>Our Vision</h2>
          <p>
            To drastically reduce the prices of essential goods in Nigeria through
            mass production and enhanced accessibility.
          </p>
        </div>

        <div className="about-section fade-in" id="mission">
          <h2>Our Mission</h2>
          <p>
            To collaborate with Nigerian governments in providing the leadership
            needed to make life easier for all Nigerians.
          </p>
        </div>
      </section>
    </div>
  );
};

export default About;
